






import vue from "vue";

interface Methods {
  emitEndExercise: () => void;
  emitNextExercise: () => void;
  handleButtonClick: () => void;
}

interface Computed {
  derivedNextButtonText: string;
}

export default vue.extend<any, Methods, Computed, any>({
  name: "WritingReviewFooter",

  props: {
    nextExercise: {
      type: Object,
      default: undefined
    }
  },

  methods: {
    emitEndExercise() {
      this.$emit("end-exercise");
    },

    emitNextExercise() {
      this.$emit("next-exercise");
    },

    handleButtonClick() {
      if (this.nextExercise) {
        this.emitNextExercise();
      } else {
        this.emitEndExercise();
      }
    }
  },

  computed: {
    derivedNextButtonText() {
      if (this.nextExercise) {
        return this.$__("exercise.next");
      } else {
        return this.$__("exercise.end");
      }
    }
  }
});
